import { message } from 'antd';

import i18n from '@/i18n';

/**
 * 下载文件
 * @param res    资源blob
 * @param filename   文件名
 */
export const downloadFile = (res: Blob, filename: string) => {
  const a = document.createElement('a');
  const URL = window.URL || window.webkitURL;
  const href = URL.createObjectURL(res);
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(href);
};

export const downloadImage = (url: string, filename: string) => {
  const img = new Image();
  const time = `_t=${Date.now()}`;

  img.crossOrigin = 'anonymous';
  img.src = `${url}${url.indexOf('?') === -1 ? '?' : '&'}${time}`;
  img.addEventListener('load', () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;

    canvas.width = img.width;
    canvas.height = img.height;

    // 将图片绘制到 canvas 上
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    // 将 canvas 内容转换为 Blob 并触发下载
    canvas.toBlob((blob) => {
      if (!blob) {
        console.error('无法生成 Blob');
        return;
      }

      downloadFile(blob, filename);
    }, 'image/png');
  });
  img.addEventListener('error', () => {
    message.error(i18n.t('error.imageLoadError'));
  });
};

/**
 * 是否是朴素对象
 * @param obj
 */
export const isPlainObject = (obj: any) => {
  if (typeof obj !== 'object' || obj === null) return false;

  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
};

/**
 * 对象转数组
 * @param obj
 */
export const objectToArray = (
  obj: Record<string | number, string | number>,
) => {
  return Object.entries(obj).map(([value, label]) => {
    return {
      label,
      value,
    };
  });
};
